// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.product-content {
    border: 1px solid #dfe5e9;
    margin-bottom: 20px;
    margin-top: 12px;
    background: #fff
}

.product-content .carousel-control.left {
    margin-left: 0
}

.product-content .product-image {
    background-color: #fff;
    display: block;
    min-height: 238px;
    overflow: hidden;
    position: relative
}

.product-content .product-deatil {
    border-bottom: 1px solid #dfe5e9;
    padding-bottom: 17px;
    padding-left: 16px;
    padding-top: 16px;
    position: relative;
    background: #fff
}

.product-content .product-deatil h5 a {
    color: #2f383d;
    font-size: 15px;
    line-height: 19px;
    text-decoration: none;
    padding-left: 0;
    margin-left: 0
}

.product-content .product-deatil h5 a span {
    color: #9aa7af;
    display: block;
    font-size: 13px
}

.product-content .product-deatil span.tag1 {
    border-radius: 50%;
    color: #fff;
    font-size: 15px;
    height: 50px;
    padding: 13px 0;
    position: absolute;
    right: 10px;
    text-align: center;
    top: 10px;
    width: 50px
}

.product-content .product-deatil span.sale {
    background-color: #21c2f8
}

.product-content .product-deatil span.discount {
    background-color: #71e134
}

.product-content .product-deatil span.hot {
    background-color: #fa9442
}

.product-content .description {
    font-size: 12.5px;
    line-height: 20px;
    padding: 10px 14px 16px 19px;
    background: #fff
}

.product-content .product-info {
    padding: 11px 19px 10px 20px
}

.product-content .product-info a.add-to-cart {
    color: #2f383d;
    font-size: 13px;
    padding-left: 16px
}

.product-content name.a {
    padding: 5px 10px;
    margin-left: 16px
}

.product-info.smart-form .btn {
    padding: 6px 12px;
    margin-left: 12px;
    margin-top: -10px
}

.product-entry .product-deatil {
    border-bottom: 1px solid #dfe5e9;
    padding-bottom: 17px;
    padding-left: 16px;
    padding-top: 16px;
    position: relative
}

.product-entry .product-deatil h5 a {
    color: #2f383d;
    font-size: 15px;
    line-height: 19px;
    text-decoration: none
}

.product-entry .product-deatil h5 a span {
    color: #9aa7af;
    display: block;
    font-size: 13px
}

.load-more-btn {
    background-color: #21c2f8;
    border-bottom: 2px solid #037ca5;
    border-radius: 2px;
    border-top: 2px solid #0cf;
    margin-top: 20px;
    padding: 9px 0;
    width: 100%
}

.product-block .product-deatil p.price-container span,
.product-content .product-deatil p.price-container span,
.product-entry .product-deatil p.price-container span,
.shipping table tbody tr td p.price-container span,
.shopping-items table tbody tr td p.price-container span {
    color: #21c2f8;
    font-family: Lato, sans-serif;
    font-size: 24px;
    line-height: 20px
}

.product-info.smart-form .rating label {
    margin-top: 0
}

.product-wrap .product-image span.tag2 {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    padding: 10px 0;
    color: #fff;
    font-size: 11px;
    text-align: center
}

.product-wrap .product-image span.sale {
    background-color: #57889c
}

.product-wrap .product-image span.hot {
    background-color: #a90329
}

.shop-btn {
    position: relative
}

.shop-btn>span {
    background: #a90329;
    display: inline-block;
    font-size: 10px;
    box-shadow: inset 1px 1px 0 rgba(0, 0, 0, .1), inset 0 -1px 0 rgba(0, 0, 0, .07);
    font-weight: 700;
    border-radius: 50%;
    padding: 2px 4px 3px!important;
    text-align: center;
    line-height: normal;
    width: 19px;
    top: -7px;
    left: -7px
}

.description-tabs {
    padding: 30px 0 5px!important
}

.description-tabs .tab-content {
    padding: 10px 0
}

.product-deatil {
    padding: 30px 30px 50px
}

.product-deatil hr+.description-tabs {
    padding: 0 0 5px!important
}

.product-deatil .carousel-control.left,
.product-deatil .carousel-control.right {
    background: none!important
}

.product-deatil .glyphicon {
    color: #3276b1
}

.product-deatil .product-image {
    border-right: none!important
}

.product-deatil .name {
    margin-top: 0;
    margin-bottom: 0
}

.product-deatil .name small {
    display: block
}

.product-deatil .name a {
    margin-left: 0
}

.product-deatil .price-container {
    font-size: 24px;
    margin: 0;
    font-weight: 300
}

.product-deatil .price-container small {
    font-size: 12px
}

.product-deatil .fa-2x {
    font-size: 16px!important
}

.product-deatil .fa-2x>h5 {
    font-size: 12px;
    margin: 0
}

.product-deatil .fa-2x+a,
.product-deatil .fa-2x+a+a {
    font-size: 13px
}

.profile-message ul {
  list-style: none ;  
}

.product-deatil .certified {
    margin-top: 10px
}

.product-deatil .certified ul {
    padding-left: 0
}

.product-deatil .certified ul li:not(first-child) {
    margin-left: -3px
}

.product-deatil .certified ul li {
    display: inline-block;
    background-color: #f9f9f9;
    border: 1px solid #ccc;
    padding: 13px 19px
}

.product-deatil .certified ul li:first-child {
    border-right: none
}

.product-deatil .certified ul li a {
    text-align: left;
    font-size: 12px;
    color: #6d7a83;
    line-height: 16px;
    text-decoration: none
}

.product-deatil .certified ul li a span {
    display: block;
    color: #21c2f8;
    font-size: 13px;
    font-weight: 700;
    text-align: center
}

.product-deatil .message-text {
    width: calc(100% - 70px)
}

@media only screen and (min-width:1024px) {
    .product-content div[class*=col-md-4] {
        padding-right: 0
    }
    .product-content div[class*=col-md-8] {
        padding: 0 13px 0 0
    }
    .product-wrap div[class*=col-md-5] {
        padding-right: 0
    }
    .product-wrap div[class*=col-md-7] {
        padding: 0 13px 0 0
    }
    .product-content .product-image {
        border-right: 1px solid #dfe5e9
    }
    .product-content .product-info {
        position: relative
    }
}

.message img.online {
    width:40px;
    height:40px;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/detailsbreak.css"],"names":[],"mappings":";AACA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB;AACJ;;AAEA;IACI,gCAAgC;IAChC,oBAAoB;IACpB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,eAAe;IACf;AACJ;;AAEA;IACI,cAAc;IACd,cAAc;IACd;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,4BAA4B;IAC5B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB;AACJ;;AAEA;IACI,gCAAgC;IAChC,oBAAoB;IACpB,kBAAkB;IAClB,iBAAiB;IACjB;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB;AACJ;;AAEA;IACI,cAAc;IACd,cAAc;IACd;AACJ;;AAEA;IACI,yBAAyB;IACzB,gCAAgC;IAChC,kBAAkB;IAClB,0BAA0B;IAC1B,gBAAgB;IAChB,cAAc;IACd;AACJ;;AAEA;;;;;IAKI,cAAc;IACd,6BAA6B;IAC7B,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,eAAe;IACf,gFAAgF;IAChF,gBAAgB;IAChB,kBAAkB;IAClB,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,SAAS;IACT;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,SAAS;IACT;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;;IAEI;AACJ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB;AACJ;;AAEA;IACI,cAAc;IACd,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;AACJ;;AAEA;IACI,UAAU;IACV,WAAW;AACf","sourcesContent":["\n.product-content {\n    border: 1px solid #dfe5e9;\n    margin-bottom: 20px;\n    margin-top: 12px;\n    background: #fff\n}\n\n.product-content .carousel-control.left {\n    margin-left: 0\n}\n\n.product-content .product-image {\n    background-color: #fff;\n    display: block;\n    min-height: 238px;\n    overflow: hidden;\n    position: relative\n}\n\n.product-content .product-deatil {\n    border-bottom: 1px solid #dfe5e9;\n    padding-bottom: 17px;\n    padding-left: 16px;\n    padding-top: 16px;\n    position: relative;\n    background: #fff\n}\n\n.product-content .product-deatil h5 a {\n    color: #2f383d;\n    font-size: 15px;\n    line-height: 19px;\n    text-decoration: none;\n    padding-left: 0;\n    margin-left: 0\n}\n\n.product-content .product-deatil h5 a span {\n    color: #9aa7af;\n    display: block;\n    font-size: 13px\n}\n\n.product-content .product-deatil span.tag1 {\n    border-radius: 50%;\n    color: #fff;\n    font-size: 15px;\n    height: 50px;\n    padding: 13px 0;\n    position: absolute;\n    right: 10px;\n    text-align: center;\n    top: 10px;\n    width: 50px\n}\n\n.product-content .product-deatil span.sale {\n    background-color: #21c2f8\n}\n\n.product-content .product-deatil span.discount {\n    background-color: #71e134\n}\n\n.product-content .product-deatil span.hot {\n    background-color: #fa9442\n}\n\n.product-content .description {\n    font-size: 12.5px;\n    line-height: 20px;\n    padding: 10px 14px 16px 19px;\n    background: #fff\n}\n\n.product-content .product-info {\n    padding: 11px 19px 10px 20px\n}\n\n.product-content .product-info a.add-to-cart {\n    color: #2f383d;\n    font-size: 13px;\n    padding-left: 16px\n}\n\n.product-content name.a {\n    padding: 5px 10px;\n    margin-left: 16px\n}\n\n.product-info.smart-form .btn {\n    padding: 6px 12px;\n    margin-left: 12px;\n    margin-top: -10px\n}\n\n.product-entry .product-deatil {\n    border-bottom: 1px solid #dfe5e9;\n    padding-bottom: 17px;\n    padding-left: 16px;\n    padding-top: 16px;\n    position: relative\n}\n\n.product-entry .product-deatil h5 a {\n    color: #2f383d;\n    font-size: 15px;\n    line-height: 19px;\n    text-decoration: none\n}\n\n.product-entry .product-deatil h5 a span {\n    color: #9aa7af;\n    display: block;\n    font-size: 13px\n}\n\n.load-more-btn {\n    background-color: #21c2f8;\n    border-bottom: 2px solid #037ca5;\n    border-radius: 2px;\n    border-top: 2px solid #0cf;\n    margin-top: 20px;\n    padding: 9px 0;\n    width: 100%\n}\n\n.product-block .product-deatil p.price-container span,\n.product-content .product-deatil p.price-container span,\n.product-entry .product-deatil p.price-container span,\n.shipping table tbody tr td p.price-container span,\n.shopping-items table tbody tr td p.price-container span {\n    color: #21c2f8;\n    font-family: Lato, sans-serif;\n    font-size: 24px;\n    line-height: 20px\n}\n\n.product-info.smart-form .rating label {\n    margin-top: 0\n}\n\n.product-wrap .product-image span.tag2 {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    width: 36px;\n    height: 36px;\n    border-radius: 50%;\n    padding: 10px 0;\n    color: #fff;\n    font-size: 11px;\n    text-align: center\n}\n\n.product-wrap .product-image span.sale {\n    background-color: #57889c\n}\n\n.product-wrap .product-image span.hot {\n    background-color: #a90329\n}\n\n.shop-btn {\n    position: relative\n}\n\n.shop-btn>span {\n    background: #a90329;\n    display: inline-block;\n    font-size: 10px;\n    box-shadow: inset 1px 1px 0 rgba(0, 0, 0, .1), inset 0 -1px 0 rgba(0, 0, 0, .07);\n    font-weight: 700;\n    border-radius: 50%;\n    padding: 2px 4px 3px!important;\n    text-align: center;\n    line-height: normal;\n    width: 19px;\n    top: -7px;\n    left: -7px\n}\n\n.description-tabs {\n    padding: 30px 0 5px!important\n}\n\n.description-tabs .tab-content {\n    padding: 10px 0\n}\n\n.product-deatil {\n    padding: 30px 30px 50px\n}\n\n.product-deatil hr+.description-tabs {\n    padding: 0 0 5px!important\n}\n\n.product-deatil .carousel-control.left,\n.product-deatil .carousel-control.right {\n    background: none!important\n}\n\n.product-deatil .glyphicon {\n    color: #3276b1\n}\n\n.product-deatil .product-image {\n    border-right: none!important\n}\n\n.product-deatil .name {\n    margin-top: 0;\n    margin-bottom: 0\n}\n\n.product-deatil .name small {\n    display: block\n}\n\n.product-deatil .name a {\n    margin-left: 0\n}\n\n.product-deatil .price-container {\n    font-size: 24px;\n    margin: 0;\n    font-weight: 300\n}\n\n.product-deatil .price-container small {\n    font-size: 12px\n}\n\n.product-deatil .fa-2x {\n    font-size: 16px!important\n}\n\n.product-deatil .fa-2x>h5 {\n    font-size: 12px;\n    margin: 0\n}\n\n.product-deatil .fa-2x+a,\n.product-deatil .fa-2x+a+a {\n    font-size: 13px\n}\n\n.profile-message ul {\n  list-style: none ;  \n}\n\n.product-deatil .certified {\n    margin-top: 10px\n}\n\n.product-deatil .certified ul {\n    padding-left: 0\n}\n\n.product-deatil .certified ul li:not(first-child) {\n    margin-left: -3px\n}\n\n.product-deatil .certified ul li {\n    display: inline-block;\n    background-color: #f9f9f9;\n    border: 1px solid #ccc;\n    padding: 13px 19px\n}\n\n.product-deatil .certified ul li:first-child {\n    border-right: none\n}\n\n.product-deatil .certified ul li a {\n    text-align: left;\n    font-size: 12px;\n    color: #6d7a83;\n    line-height: 16px;\n    text-decoration: none\n}\n\n.product-deatil .certified ul li a span {\n    display: block;\n    color: #21c2f8;\n    font-size: 13px;\n    font-weight: 700;\n    text-align: center\n}\n\n.product-deatil .message-text {\n    width: calc(100% - 70px)\n}\n\n@media only screen and (min-width:1024px) {\n    .product-content div[class*=col-md-4] {\n        padding-right: 0\n    }\n    .product-content div[class*=col-md-8] {\n        padding: 0 13px 0 0\n    }\n    .product-wrap div[class*=col-md-5] {\n        padding-right: 0\n    }\n    .product-wrap div[class*=col-md-7] {\n        padding: 0 13px 0 0\n    }\n    .product-content .product-image {\n        border-right: 1px solid #dfe5e9\n    }\n    .product-content .product-info {\n        position: relative\n    }\n}\n\n.message img.online {\n    width:40px;\n    height:40px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
